var _path;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var s = Object.getOwnPropertySymbols(e); for (r = 0; r < s.length; r++) o = s[r], t.includes(o) || {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (e.includes(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgOffer(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 119,
    height: 101,
    viewBox: "0 0 119 101",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M59.0176 0.5L67.5806 16.3626L83.0174 4.82273L83.2261 22.2653L102.867 17.0435L94.6857 33.05L115.135 35.0491L99.978 46.852L117.7 55.7264L98.1878 61.2847L110.118 75.5L89.6248 73.8527L93.7003 90.9509L75.7694 82.3827L71.2856 99.4074L59.0176 85.4L46.7495 99.4074L42.2657 82.3827L24.3348 90.9509L28.4103 73.8527L7.917 75.5L19.8473 61.2847L0.334957 55.7264L18.0571 46.852L2.89967 35.0491L23.3494 33.05L15.1677 17.0435L34.809 22.2653L35.0177 4.82273L50.4545 16.3626L59.0176 0.5Z",
    fill: "#096731"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgOffer);
export default __webpack_public_path__ + "static/media/Offer.4d75e4f5d61c7dc2f812e0a5324ec6e9.svg";
export { ForwardRef as ReactComponent };